export enum ConversationMessageErrorTypeEnum {
  Ephemeral = 'Temporária',
  Reaction = 'Reação',
}
